import React, { useState, useEffect } from "react";
import {
  HashRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom"; //BrowserRouter
import Layout from "./layouts/Layout";
import "./App.scss";
import fakeData from "./FakeData";
import { Spinner } from "./components/Ui/EiedUi";
import PrivateRoute from "./hocs/PrivateRoute";
import Alert from "components/Ui/Alert/Alert";
import AlertState from "stateManagement/alert/AlertState";
import { setTheme } from 'stateManagement/actions/themeAction'
import { useDispatch, useSelector } from 'react-redux'
import { apiFactory } from "services/ApiFactory";
import { checkNull } from "utils/utils";
//import {AuthenticationProvider} from './contexts/Basic/AuthenticationContext'

// Pages

const Login = React.lazy(() => import("./pages/Login2/Login2"));
// const Register = React.lazy(() => import('./views/Pages/Register'));
const Page404 = React.lazy(() => import("./pages/Page404/PictorialPage404"));
const Page500 = React.lazy(() => import("./pages/Page500/Page500"));

function App() {
  const theme = useSelector(state => state.themeState.theme);
  const themeDispatcher = useDispatch();
  // const [appTheme, setAppTheme] = useState('light');
  const toggleTheme = theme => {
    if (theme === 'light' || checkNull(theme)) {
      themeDispatcher(setTheme('light'));
    } else if (theme === 'dark') {
      themeDispatcher(setTheme('dark'))
    } 
  };

  // useEffect(() => {
  //   debugger;
  //   document.body.className = theme;
  // }, [theme]);

  return (
    // <AuthenticationProvider>
      <AlertState>
        <Router>
          <Alert />
          <React.Suspense fallback={<Spinner />}>
            <Switch>
              {/* <Route exact path="/login" name="Login Page" component={<Login theme={theme}/>} /> */}
              <Route exact path="/login" name="Login Page" component={Login} />
              <Route exact path="/404" name="Page 404" component={Page404} />
              <Route exact path="/500" name="Page 500" component={Page500} />
              {/* <PrivateRoute  path="/Test" name="Test" render={props => <Page404 />} /> */}
              {/* <PrivateRoute  path="/Test" name="Test" component={Test}  />
               <PrivateRoute path="/" name="Home" render={props => <Layout {...props} fakeData={fakeData} />} />   */}
              <PrivateRoute
                path="/"
                name="Home"
                render={(props) => <Layout themeClass={`app-theme-${theme}`} {...props} fakeData={fakeData} toggleTheme={toggleTheme}/>}
              />
              <Redirect to="/404" />
            </Switch>
          </React.Suspense>
        </Router>
      </AlertState>
    // </AuthenticationProvider>
  );
}

export default App;
